export enum VIEW_PAYLOAD_KEYS {
  customerStatus = 'customer_status',
  customerId = 'customer_id',
  customerSubscriptionPlanType = 'customer_subscription_plan_type',
  errorDisplayType = 'error_display_type',
  errorMessages = 'error_messages',
  errorType = 'error_type',
  languageCode = 'language_code',
  orderCouponCode = 'order_coupon_code',
  orderCurrency = 'order_currency',
  orderDiscount = 'order_discount',
  orderId = 'order_id',
  orderPaymentType = 'order_payment_type',
  orderSubtotal = 'order_subtotal',
  orderTax = 'order_tax',
  orderTotal = 'order_total',
  subscriptionPlanName = 'subscription_plan_name',
  subscriptionPlanId = 'subscription_plan_id',
  subscriptionPlanListPrice = 'subscription_plan_list_price',
  subscriptionPlanNetPrice = 'subscription_plan_net_price',
  subscriptionId = 'subscription_id',
  subscriptionContractId = 'subscription_contract_id',
  pageContentType = 'page_content_type',
  pageName = 'page_name',
  pageTemplateName = 'page_template_name',
  siteCurrency = 'site_currency',
  siteRegion = 'site_region',
  siteSection = 'site_section',
  siteType = 'site_type',
  eventType = 'event_type',
  eventName = 'event_name',
  destinationUrl = 'destination_url',
}

export enum LINK_PAYLOAD_KEYS {
  eventType = 'event_type',
  eventName = 'event_name',
  pageName = 'page_name',
  customerId = 'customer_id',
  upgradePlan = 'upgrade_plan',
  downgradePlan = 'downgrade_plan',
  enrollPlan = 'enroll_subscription_plan',
  extendPlan = 'extend_subscription_plan',
  renewalTerm = 'renewal_term',
  subscriptionPlanName = 'subscription_plan_name',
  subscriptionPlanId = 'subscription_plan_id',
  subscriptionPlanListPrice = 'subscription_plan_list_price',
  subscriptionPlanNetPrice = 'subscription_plan_net_price',
  subscriptionId = 'subscription_id',
  activationFeeCheckbox = 'activation_fee_checkbox',
}

export enum CUSTOMER_STATUSES {
  loggedIn = 'logged_in',
  notLoggedIn = 'not_logged_in',
}

export enum PAGE_CONTENT_TYPES {
  home = 'home',
  myAccount = 'my_account',
  checkout = 'checkout',
  contact = 'contact',
  login = 'login',
  orderConfirmation = 'order_confirmation',
  forgotPassword = 'forgot_password',
}

export const SITE_TYPE = 'epson ready ink:us'

export enum PAGE_TEMPLATE_NAMES {
  home = 'home',
  myAccount = 'my_account',
  signUp = 'sign_up',
  login = 'login',
  contactUs = 'contact_us',
  paymentAndShipping = 'payment_and_shipping',
  reviewTerms = 'review_terms',
  congratulations = 'congratulations',
  confirmEmail = 'confirm_email',
  forgotPassword = 'forgot_password',
}

export enum SITE_SECTIONS {
  home = 'Home',
  login = 'Log in',
  signUp = 'Sign up',
  contact = 'Contact',
  myAccount = 'My account',
  paymentAndShipping = 'Payment & shipping',
  businessDetails = 'Business details',
  paymentDetails = 'Payment details',
  shippingAddress = 'Shipping address',
  billingAddress = 'Billing address',
  reviewTerms = 'Review terms',
  congratulations = 'Congratulations',
  confirmEmail = 'Confirm email',
  forgotPassword = 'Forgot password',
}
